<template>
  <b-form-select
    v-if="type === 'select'"
    :options="options"
    :value="value"
    @input="onInput"
    size="sm"
  />
  <b-form-input
    v-else
    type="number"
    :value="value"
    :placeholder="placeholder"
    :disabled="disabled"
    @input="onInput"
    size="sm"
  />
</template>
<script>
import { BFormInput, BFormSelect } from "bootstrap-vue";
import { arrayProp, booleanProp, stringProp } from "@/helpers/props";
export default {
  components: {
    BFormInput,
    BFormSelect,
  },
  props: {
    value: stringProp(),
    type: stringProp("input"),
    options: arrayProp(),
    placeholder: stringProp("0"),
    disabled: booleanProp(false),
  },
  methods: {
    onInput(val) {
      this.$emit("changeInput", val);
    },
  },
};
</script>
